import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCookieConsent } from '@/hooks/useCookieConsent';

const CookieConsent = () => {
  const { showBanner, accept, decline } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6"
    >
      <div className="mx-auto max-w-4xl rounded-lg border border-gold/20 bg-navy/95 backdrop-blur-sm p-4 md:p-6 shadow-elegant">
        <div className="flex flex-col gap-4">
          {/* Header */}
          <div className="flex items-center gap-2">
            <Cookie className="h-5 w-5 text-gold" aria-hidden="true" />
            <h2 
              id="cookie-consent-title" 
              className="text-lg font-semibold text-cream"
            >
              הגדרות עוגיות
            </h2>
          </div>

          {/* Description */}
          <p 
            id="cookie-consent-description" 
            className="text-cream/80 text-sm md:text-base"
          >
            אתר זה משתמש בעוגיות לניתוח תעבורה ושיפור חווית המשתמש. 
            לפרטים נוספים ראו את{' '}
            <Link 
              to="/privacy" 
              className="text-gold hover:text-gold/80 underline underline-offset-2 transition-colors"
            >
              מדיניות הפרטיות
            </Link>{' '}
            שלנו.
          </p>

          {/* Buttons */}
          <div className="flex flex-col-reverse sm:flex-row gap-3 sm:justify-end">
            <Button
              variant="gold-outline"
              onClick={decline}
              className="w-full sm:w-auto"
            >
              דחייה
            </Button>
            <Button
              variant="gold"
              onClick={accept}
              className="w-full sm:w-auto"
            >
              אישור הכל
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
